import React from "react"
import { inputBox, high } from "./input.module.css"

export const Field = ( {
  type = "text",
  name,
  label = "",
  input,
  value = "",
  disabled = false,
  placeholder = "",
  onChange = () => { },
} ) => {

  return (
    <span className={ inputBox }>
      <input
        disabled={ disabled }
        type={ type }
        value={ input ? input.values[ name ] : value }
        onChange={
          onChange
            ? onChange
            : ( e ) => input.setValues( { ...input.values, [ name ]: e.target.value } )
        }
        placeholder={ placeholder }
        name={ name } />
      {label && <label className={ high }>{ label }</label> }
    </span>
  )
}

export default Field